import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.dein-hundeleben.at/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.hash = '#/login';
    }
    return Promise.reject(error);
  }
);

const authService = {
  register: (userData) => {
    return api.post('/auth/register', userData);
  },

  login: (userData) => {
    return api.post('/auth/login', userData);
  },

  getCurrentUser: () => {
    return api.get('/auth/profile');
  },

  logout: () => {
    localStorage.removeItem('token');
  }
};

export default authService;
export { api };
